<div class="layout-gutter-left"></div>
<div class="layout-content">

  <div class="aside-left-control">
    <div class="aside-left-control-header">

      <div class="actions left-actions">
        @if (masterViewModel) {
          <nts-text-button  (onClicked)="onMasterAreaSelected.emit()" icon="table-rows" [title]="'CMD_NavigationPanel_SelectMasterArea_Description' | NTSTranslate"></nts-text-button>
        }
        @if (snapShotListViewModel) {
          <nts-text-button  (onClicked)="onSnapShotSelected.emit()" icon="history" [title]="'CMD_NavigationPanel_SelectSnapShot_Description' | NTSTranslate"></nts-text-button>
        }
      </div>
      <div class="actions right-actions">
        <nts-text-button (onClicked)="onNavigationPanelCollapsed.emit()" [icon]="'sidebar-collapse'" [title]="'CMD_NavigationPanel_Close_Description' | NTSTranslate"></nts-text-button>
      </div>

    </div>
    <div class="aside-left-control-content">
      @if (masterViewModel) {
        <nts-master-area-container class="master-area-container" [hidden]="!masterViewModel?.isSelected"
          [masterViewModel]="masterViewModel">
        </nts-master-area-container>
      }
      @if (snapShotListViewModel) {
        <nts-snap-shot-list-container class="snap-shot-list-container" [hidden]="!snapShotListViewModel?.isSelected"
          [snapShotListViewModel]="snapShotListViewModel">
        </nts-snap-shot-list-container>
      }
    </div>
  </div>

</div>
<div class="layout-gutter-right"></div>